export default {
      id: "pay_amex-usage",
      viewBox: "0 0 94 34",
      url: __webpack_public_path__ + "sprite.svg#pay_amex",
      toString: function () {
        return this.url;
      }
    }